import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"

import { startGoogleLogin, startLoginEmailPassword } from "../../actions/auth"
import { useForm } from "../../hooks/useForm"

const LoginScreen = () => {

    const dispatch = useDispatch()
    const { msgError, loading  } = useSelector(state => state.ui)

    const [ formValues, handleInputChange, reset ] = useForm({
        email: 'josediaz@gmail.com',
        password: '123456'
    })

    const { email, password } = formValues

    const handleLogin = (e) => {
        e.preventDefault()

        dispatch(startLoginEmailPassword(email, password))
    }

    const handleGoogleLogin = () => {
        dispatch(startGoogleLogin())
    }

    return (
        <>
            <h3 className="auth__title mb-5">Login</h3>

            <form 
                className="animate__animated animate__fadeIn"
                onSubmit={ handleLogin }
            >
                { msgError &&
                    <div className="auth__alert-error">
                        { msgError }
                    </div>
                }

                <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    className="auth__input"
                    autoComplete="off"
                    value={ email}
                    onChange={ handleInputChange }
                />

                <input
                    type="password"
                    placeholder="Password"
                    name="password"
                    className="auth__input"
                    value={ password }
                    onChange={ handleInputChange }
                />

                <button
                    type="submit"
                    className="btn btn-primary btn-full"
                    disabled={ loading }
                >
                    Login
                </button>

                <div className="auth__social-networks">
                    <p>Login with social networks</p>

                    <div
                        className="google-btn"
                        onClick={ handleGoogleLogin }
                    >
                        <div className="google-icon-wrapper">
                            <img className="google-icon" src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg" alt="google button" />
                        </div>

                        <p className="btn-text">
                            <b>Sign in with google</b>
                        </p>
                    </div>
                </div>

                <Link to="/auth/register" className="links">
                    Create new account
                </Link>
            </form>
        </>
    )
}

export default LoginScreen